import React from 'react';
import KickImage from 'Reuseables/KickImage';

import {
  Container,
  Row,
  Col,
  Image
} from 'reactstrap';

import IconLogo from '../../images/logo.png';

class FooterRaffle extends React.Component {
  render() {
    return (
      <Container fluid className={`footer-container raffle-footer`}>
        <Row>
          <Col className="footer-col-left">
            <div className="raffle-footer-left">
              <p>Disclaimer: This information will be safely stored and be used solely for this campaign marketing purposes. We will never share it with any third party. </p>
            </div>
          </Col>
          <Col className="footer-col-right">
            <div className="raffle-footer-right">
            <KickImage 
              src={IconLogo}
              alt="icon logo"
            />
            </div>
          </Col>
        </Row>
      </Container>
    )
  }
}

export default FooterRaffle;